import type { AgentConfig } from "~/shared/types";
import { makeStringComparator } from "~/utils/comparator";

const agentModules = import.meta.glob<{ default: AgentConfig }>("./*/config.ts", { eager: true });

export const getAgentConfigDisplayName = (config: AgentConfig) => config.displayNameOverride ?? config.name;

export const TEMPLATE_AGENT_CONFIGS: AgentConfig[] = Object.values(agentModules)
  .map((e) => e.default)
  .sort(makeStringComparator(getAgentConfigDisplayName));

export const AGENT_CONFIG_MAP = new Map(TEMPLATE_AGENT_CONFIGS.map((config) => [config.name, config] as const));
